import { formatDate } from "@angular/common";
import { Component, OnDestroy, OnInit } from "@angular/core";
import { FormControl } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { Router, ActivatedRoute } from "@angular/router";
import { Subscription } from "rxjs";
import { ITableColumnHeader } from "src/app/models/table-column-header";
import { ApiService } from "src/app/providers/api.service";
import { LoaderServiceService } from "src/app/providers/loader-service.service";
import { NavigationService } from "src/app/providers/navigation.service";
import { AddCustomerComponent } from "src/app/shared/components/add-customer/add-customer.component";
import { CreateInvoiceForCustomersComponent } from "src/app/shared/components/create-invoice-for-customers/create-invoice-for-customers.component";
import { CustomConfirmDialogComponent } from "src/app/shared/components/custom-confirm-dialog/custom-confirm-dialog.component";
import { PaymentIntimationComponent } from "src/app/shared/components/payment-intimation/payment-intimation.component";
import { SelectBusinessCountryComponent } from "src/app/shared/components/select-business-country/select-business-country.component";
import { SM_CONSTANTS } from "src/app/shared/constants/sm-constants";
import { COUNTRY_CODES } from "src/app/shared/data/country-codes";
import { CustomersViewDetailsComponent } from "../new-v2-component/customers-view-details/customers-view-details.component";
import { YoutubeEmbedVideoComponent } from "../new-v2-component/youtube-embed-video/youtube-embed-video.component";
import { DialogService } from "src/app/providers/dialog.service";
import { Share } from "@capacitor/share";
import { AuthService } from "src/app/providers/auth.service";

@Component({
  selector: "sm-all-customers",
  templateUrl: "./all-customers.component.html",
  styleUrls: ["./all-customers.component.scss"],
})
export class AllCustomersComponent implements OnInit, OnDestroy {
  hidediv: boolean = false;
  searchString: FormControl = new FormControl("");
  loader: boolean = false;
  apisub: Subscription;
  businessListData: any[] = [];
  serviceTimings: any[] = [];
  finalServiceTimings: any[] = [];
  selectedBusiness: any;
  selectedServiceType: any = "1";
  groupedServiceTimings: any = null;
  page: number = 1;
  datalength!: number;
  toShowTimings: boolean = false;
  customersData: any[] = [];
  daysOfWeek = [
    { day: 1, name: "Sunday" },
    { day: 2, name: "Monday" },
    { day: 3, name: "Tuesday" },
    { day: 4, name: "Wednesday" },
    { day: 5, name: "Thursday" },
    { day: 6, name: "Friday" },
    { day: 7, name: "Saturday" },
  ];
  tableDisplayColumns: ITableColumnHeader[] = [
    {
      columnName: "Name",
      columnProperty: "name",
    },
    {
      columnName: "Phone",
      columnProperty: "cust_phone",
    },
    {
      columnName: "Gender",
      columnProperty: "gender1",
    },
    // {
    //   columnName: 'Date of birth',
    //   columnProperty: "dob1"
    // },
    {
      columnName: "Last booking date",
      columnProperty: "l_booking_date",
    },
    // {
    //   columnName: this.translateService.instant('customers.column_headers.last_booking'),
    //   columnProperty: "last_booking_date"
    // },
    {
      columnName: "Total due",
      columnProperty: "total_due",
    },
  ];
  isEmployeeAndHasBusinessButDoesNotHaveAccess: boolean = false;
  constructor(
    private apiservice: ApiService,
    private authService: AuthService,
    private loaderservice: LoaderServiceService,
    private navservice: NavigationService,
    private router: Router,
    private _modelRef: MatDialog,
    private dialog: MatDialog,
    private route: ActivatedRoute,
    private dialogService: DialogService,
  ) {
    this.navservice.hideSidebarAndNav = false;
    this.apisub = this.apiservice.apiResult.subscribe((resdata) => {
      if (
        resdata.responseType === SM_CONSTANTS.RESULT_API_GET_BASIC_ENTITY_LIST
      ) {
        this.businessListData = [];
        if (resdata.result) {
          this.businessListData = resdata.result;
          this.businessListData.forEach((element: any) => {
            // Parse if string
            element.employee_functionality_list =
              typeof element.employee_functionality_list === "string"
                ? JSON.parse(element.employee_functionality_list)
                : element.employee_functionality_list;

            const list = element.employee_functionality_list || [];

            // Set defaults
            element.member_access = 0;
            element.customer_access = 0;
            element.service_access = 0;
            element.bookings_access = 0;

            if (Array.isArray(list)) {
              list.forEach((fn: any) => {
                const access = fn?.access_status === 1 ? 1 : 0;
                const name = fn?.functionality_name || "";

                switch (name) {
                  case "Member management":
                    element.member_access = access;
                    break;

                  case "Customer management":
                    element.customer_access = access;
                    break;

                  case "Services & Packages":
                    element.service_access = access;
                    break;

                  case "Booking history":
                    element.bookings_access = access;
                    break;

                  case "Shop/In-Premise operation":
                    element.shop_bookings_access = access;
                    break;

                  case "Home service operation":
                    element.home_bookings_access = access;
                    break;

                  case "Virtual service operation":
                    element.virtual_bookings_access = access;
                    break;

                  case "Invoice history":
                    element.invoice_history_access = access;
                    break;

                  case "Shop/In-Premise Invoicing":
                    element.shop_invoice_access = access;
                    break;

                  case "Home service invoicing":
                    element.home_invoice_access = access;
                    break;

                  case "Virtual service invoicing":
                    element.virtual_invoice_access = access;
                    break;
                }
              });
            }
          });

          let checkForAccessLength = this.businessListData.length;
          this.businessListData = this.businessListData
            .map((element: any) => ({
              ...element, // Spread existing properties
              isSelected: 0, // Add the isSelected property
            }))
            .filter(
              (element: any) =>
                (element.is_owner == 1 &&
                  element.entitySubscriptionInfo &&
                  element.entitySubscriptionInfo !== "null") ||
                (element.is_owner != 1 &&
                  element.entitySubscriptionInfo &&
                  element.entitySubscriptionInfo !== "null" &&
                  element.employeeSubscriptionInfo &&
                  element.employeeSubscriptionInfo !== "null" &&
                  element.employee_status == 1 &&
                  element.customer_access == 1),
            );
          if (checkForAccessLength - this.businessListData.length > 0) {
            this.isEmployeeAndHasBusinessButDoesNotHaveAccess = true;
          }
          if (this.businessListData.length > 0) {
            this.businessListData[0].isSelected = 1;
            this.selectedBusiness = this.businessListData[0];
            localStorage.setItem(
              SM_CONSTANTS.CURRENT_ENTITY_PUBLIC_PROFILE_HASH_ID,
              this.selectedBusiness.entity_public_hash_id,
            );
            sessionStorage.setItem(
              "shop_service_status",
              this.selectedBusiness.shop_service_status,
            );
            sessionStorage.setItem(
              "home_service_status",
              this.selectedBusiness.home_service_status,
            );
            sessionStorage.setItem(
              "virtual_service_status",
              this.selectedBusiness.virtual_service_status,
            );

            sessionStorage.setItem(
              SM_CONSTANTS.EMPLOYEE_SHOP_SERVICE_INVOICE_ACCESS,
              this.selectedBusiness.shop_invoice_access,
            );
            sessionStorage.setItem(
              SM_CONSTANTS.EMPLOYEE_HOME_SERVICE_INVOICE_ACCESS,
              this.selectedBusiness.home_invoice_access,
            );
            sessionStorage.setItem(
              SM_CONSTANTS.EMPLOYEE_VIRTUAL_SERVICE_INVOICE_ACCESS,
              this.selectedBusiness.virtual_invoice_access,
            );

            localStorage.setItem(
              SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID,
              this.selectedBusiness.employee_hash_id,
            );
            let isEntityForeign =
              this.selectedBusiness.currency == "INR" ? "0" : "1";

            localStorage.setItem(
              SM_CONSTANTS.IS_ENTITY_FOREIGN,
              isEntityForeign,
            );
            let countryList: any[] = COUNTRY_CODES;
            sessionStorage.setItem(
              "isEntityIndividual",
              this.selectedBusiness.revenue_model == 2 ? "1" : "0",
            );

            let selectedCurrency = {
              currency: this.selectedBusiness.currency,
              currencySymbol: this.selectedBusiness.currency_symbol,
              countryCode: this.selectedBusiness.entity_country_code,
              code: countryList.find(
                (country) =>
                  country.dial_code ===
                    this.selectedBusiness.entity_country_code &&
                  country.currency === this.selectedBusiness.currency,
              )?.code,
            };
            sessionStorage.setItem(
              SM_CONSTANTS.CURRENCY_FOR_SUBSCRIPTION_PAYMENT,
              JSON.stringify(selectedCurrency),
            );
          }
          console.log("bl", this.selectedBusiness);

          if (this.selectedBusiness) {
            this.authService.setUserRole(
              this.selectedBusiness.is_owner == 1 ? "owner" : "employee",
            );
            if (this.selectedBusiness.is_owner == 1) {
              this.isAccessForEmployeeInvoice = true;
            } else {
              const ssa = this.selectedBusiness.shop_invoice_access;
              const hsa = this.selectedBusiness.home_invoice_access;
              const vsa = this.selectedBusiness.virtual_invoice_access;

              const bsss = this.selectedBusiness.shop_service_status;
              const bhss = this.selectedBusiness.home_service_status;
              const bvss = this.selectedBusiness.virtual_service_status;

              // sessionStorage.getItem() returns a string or null.

              // 2. Check if ANY of the retrieved values is the string '1'
              if (
                (ssa == "1" && bsss != "2") ||
                (hsa == "1" && bhss != "2") ||
                (vsa == "1" && bvss != "2")
              ) {
                this.isAccessForEmployeeInvoice = true;
              }
            }
          }
        }
        if (this.businessListData.length > 0) {
          this.apiservice.getCustomersByEntityId(
            this.selectedBusiness.hash_id,
            this.page.toString(),
          );
        } else {
          this.loaderservice.showLoader = false;
          this.loader = false;
        }
      }

      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_GET_CUSTOMERS_BY_ENTITY_ID
      ) {
        this.customersData = [];
        console.log(resdata);
        if (resdata.result && resdata.result != null) {
          this.datalength = resdata.result ? resdata.result[0].total_count : 0;
          resdata.result.forEach((element: any) => {
            if (element.gender == 1) {
              element.gender1 = "Male";
            } else if (element.gender == 2) {
              element.gender1 = "Female";
            } else if (element.gender == 3) {
              element.gender1 = "Others";
            } else if (!element.gender || element.gender == "null") {
              element.gender1 = "---";
            }

            if (element.dob && element.dob != "null") {
              element.dob1 = new Date(element.dob).toLocaleDateString("en-US", {
                year: "numeric",
                month: "short",
                day: "numeric",
              });
            } else {
              element.dob1 = "---";
            }

            element.l_booking_date = "---";
            if (element.last_booking_date) {
              element.l_booking_date = this.formatDateToReadable(
                element.last_booking_date,
              );
            }

            if (!element.total_due) {
              element.total_due = 0;
            }
            element.cust_phone =
              (element.country_code ? element.country_code + " " : "") +
              element.phone;
            Object.keys(element).forEach((key) => {
              if ((element as any)[key] === null) {
                // delete (data as any)[key];
                if (
                  key != "image_thumb_url" &&
                  key != "country_code" &&
                  key != "email"
                ) {
                  (element as any)[key] = "---";
                }
              }
            });
            this.customersData.push(element);
          });
          console.log(this.customersData);
        }
        this.apiservice.getBillDiscountData(
          localStorage.getItem(
            SM_CONSTANTS.CURRENT_ENTITY_PUBLIC_PROFILE_HASH_ID,
          ),
        );
      } else if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_GET_CUSTOMERS_WITH_DUES_BY_ENTITY_ID
      ) {
        this.customersData = [];
        console.log(resdata);
        if (resdata.result && resdata.result != null) {
          resdata.result.forEach((element: any) => {
            if (element.gender == 1) {
              element.gender1 = "Male";
            } else if (element.gender == 2) {
              element.gender1 = "Female";
            } else if (element.gender == 3) {
              element.gender1 = "Others";
            } else if (!element.gender || element.gender == "null") {
              element.gender1 = "---";
            }

            if (element.dob && element.dob != "null") {
              element.dob1 = new Date(element.dob).toLocaleDateString("en-US", {
                year: "numeric",
                month: "short",
                day: "numeric",
              });
            } else {
              element.dob1 = "---";
            }
            element.l_booking_date = "---";
            if (element.last_booking_date) {
              element.l_booking_date = this.formatDateToReadable(
                element.last_booking_date,
              );
            }
            element.cust_phone =
              (element.country_code ? element.country_code + " " : "") +
              element.phone;
            Object.keys(element).forEach((key) => {
              if ((element as any)[key] === null) {
                // delete (data as any)[key];
                if (
                  key != "image_thumb_url" &&
                  key != "country_code" &&
                  key != "email"
                ) {
                  (element as any)[key] = "---";
                }
              }
            });
            this.customersData.push(element);
          });
        }
        this.loaderservice.showLoader = false;
        this.loader = false;
      } else if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_GET_LONG_ABSENT_CUSTOMERS_BY_ENTITY_ID
      ) {
        this.customersData = [];
        console.log(resdata);
        if (resdata.result && resdata.result != null) {
          resdata.result.forEach((element: any) => {
            if (element.gender == 1) {
              element.gender1 = "Male";
            } else if (element.gender == 2) {
              element.gender1 = "Female";
            } else if (element.gender == 3) {
              element.gender1 = "Others";
            } else if (!element.gender || element.gender == "null") {
              element.gender1 = "---";
            }

            if (element.dob && element.dob != "null") {
              element.dob1 = new Date(element.dob).toLocaleDateString("en-US", {
                year: "numeric",
                month: "short",
                day: "numeric",
              });
            } else {
              element.dob1 = "---";
            }

            element.l_booking_date = "---";
            if (element.last_booking_date) {
              element.l_booking_date = this.formatDateToReadable(
                element.last_booking_date,
              );
            }

            element.cust_phone =
              (element.country_code ? element.country_code + " " : "") +
              element.phone;
            Object.keys(element).forEach((key) => {
              if ((element as any)[key] === null) {
                // delete (data as any)[key];
                if (
                  key != "image_thumb_url" &&
                  key != "country_code" &&
                  key != "email"
                ) {
                  (element as any)[key] = "---";
                }
              }
            });
            this.customersData.push(element);
          });
        }
        this.loaderservice.showLoader = false;
        this.loader = false;
      } else if (
        resdata.responseType === SM_CONSTANTS.RESULT_API_GET_CUSTOMER_BY_SEARCH
      ) {
        this.customersData = [];
        console.log(resdata);
        if (resdata.result && resdata.result != null) {
          resdata.result.forEach((element: any) => {
            if (element.gender == 1) {
              element.gender1 = "Male";
            } else if (element.gender == 2) {
              element.gender1 = "Female";
            } else if (element.gender == 3) {
              element.gender1 = "Others";
            } else if (!element.gender || element.gender == "null") {
              element.gender1 = "---";
            }

            if (element.dob && element.dob != "null") {
              element.dob1 = new Date(element.dob).toLocaleDateString("en-US", {
                year: "numeric",
                month: "short",
                day: "numeric",
              });
            } else {
              element.dob1 = "---";
            }

            element.l_booking_date = "---";
            if (element.last_booking_date) {
              element.l_booking_date = this.formatDateToReadable(
                element.last_booking_date,
              );
            }

            element.cust_phone =
              (element.country_code ? element.country_code + " " : "") +
              element.phone;
            Object.keys(element).forEach((key) => {
              if ((element as any)[key] === null) {
                // delete (data as any)[key];
                if (key != "image_thumb_url") {
                  (element as any)[key] = "---";
                }
              }
            });
            this.customersData.push(element);
          });
        }
        this.loaderservice.showLoader = false;
        this.loader = false;
      }
      if (
        resdata.responseType === SM_CONSTANTS.RESULT_API_GET_ENTITY_DISCOUNT
      ) {
        this.discountInfo = null;
        if (resdata.result) {
          this.discountInfo = resdata.result;
        }
        this.loaderservice.showLoader = false;
        this.loader = false;
      }
      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_DELETE_ENTITY_CUSTOMER_DATA
      ) {
        if (resdata.result) {
          this.apiservice.getCustomersByEntityId(
            this.selectedBusiness.hash_id,
            this.page.toString(),
          );
        }
      }
      if (
        resdata.responseType === SM_CONSTANTS.RESULT_API_DELETE_ENTITY_INVOICE
      ) {
        if (resdata.result) {
          if (this.selectedValue == "0") {
            this.apiservice.getCustomersByEntityId(
              this.selectedBusiness.hash_id,
              this.page.toString(),
            );
          } else if (this.selectedValue == "1") {
            this.apiservice.getCustomersWithDuesByEntityId(
              this.selectedBusiness.hash_id,
              this.page.toString(),
            );
          } else if (this.selectedValue == "2") {
            this.apiservice.getLongAbsentCustomersByEntityId(
              this.selectedBusiness.hash_id,
              this.page.toString(),
            );
          }
        }
      }
      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_DELETE_INTERNATIONAL_INVOICE_DETAILS
      ) {
        if (resdata.result) {
          if (this.selectedValue == "0") {
            this.apiservice.getCustomersByEntityId(
              this.selectedBusiness.hash_id,
              this.page.toString(),
            );
          } else if (this.selectedValue == "1") {
            this.apiservice.getCustomersWithDuesByEntityId(
              this.selectedBusiness.hash_id,
              this.page.toString(),
            );
          } else if (this.selectedValue == "2") {
            this.apiservice.getLongAbsentCustomersByEntityId(
              this.selectedBusiness.hash_id,
              this.page.toString(),
            );
          }
        }
      }

      if (
        resdata.responseType === SM_CONSTANTS.RESULT_API_ADD_EDIT_PAYMENT_RECORD
      ) {
        if (resdata.result) {
          if (this.selectedValue == "0") {
            this.apiservice.getCustomersByEntityId(
              this.selectedBusiness.hash_id,
              this.page.toString(),
            );
          } else if (this.selectedValue == "1") {
            this.apiservice.getCustomersWithDuesByEntityId(
              this.selectedBusiness.hash_id,
              this.page.toString(),
            );
          } else if (this.selectedValue == "2") {
            this.apiservice.getLongAbsentCustomersByEntityId(
              this.selectedBusiness.hash_id,
              this.page.toString(),
            );
          }
        }
      }
      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_ADD_EDIT_INTERNATIONAL_INVOICE_PAYMENT_RECORD
      ) {
        if (resdata.result) {
          if (this.selectedValue == "0") {
            this.apiservice.getCustomersByEntityId(
              this.selectedBusiness.hash_id,
              this.page.toString(),
            );
          } else if (this.selectedValue == "1") {
            this.apiservice.getCustomersWithDuesByEntityId(
              this.selectedBusiness.hash_id,
              this.page.toString(),
            );
          } else if (this.selectedValue == "2") {
            this.apiservice.getLongAbsentCustomersByEntityId(
              this.selectedBusiness.hash_id,
              this.page.toString(),
            );
          }
        }
      }
      if (
        resdata.responseType === SM_CONSTANTS.RESULT_API_RECORD_FITNESS_INVOICE
      ) {
        if (resdata.result) {
          if (this.selectedValue == "0") {
            this.apiservice.getCustomersByEntityId(
              this.selectedBusiness.hash_id,
              this.page.toString(),
            );
          } else if (this.selectedValue == "1") {
            this.apiservice.getCustomersWithDuesByEntityId(
              this.selectedBusiness.hash_id,
              this.page.toString(),
            );
          } else if (this.selectedValue == "2") {
            this.apiservice.getLongAbsentCustomersByEntityId(
              this.selectedBusiness.hash_id,
              this.page.toString(),
            );
          }
        }
      }
      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_ADD_EDIT_FITNESS_INTERNATIONAL_INVOICE_PAYMENT_RECORD
      ) {
        if (resdata.result) {
          if (this.selectedValue == "0") {
            this.apiservice.getCustomersByEntityId(
              this.selectedBusiness.hash_id,
              this.page.toString(),
            );
          } else if (this.selectedValue == "1") {
            this.apiservice.getCustomersWithDuesByEntityId(
              this.selectedBusiness.hash_id,
              this.page.toString(),
            );
          } else if (this.selectedValue == "2") {
            this.apiservice.getLongAbsentCustomersByEntityId(
              this.selectedBusiness.hash_id,
              this.page.toString(),
            );
          }
        }
      }
    });
  }

  ngOnInit(): void {
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: {},
      queryParamsHandling: "", // Clears all other params
      replaceUrl: true,
    });
    // localStorage.removeItem(SM_CONSTANTS.CURRENT_ENTITY_HASH);
    this.loader = true;
    this.loaderservice.showLoader = true;
    this.apiservice.getBasicEntityList();
  }
  createNewBusiness() {
    this.router.navigate(["purchased-plan"]);
  }

  selectedValue: string = "0";
  changeChip(value: string) {
    this.selectedValue = value;
    this.loader = true;
    this.loaderservice.showLoader = true;
    if (value == "0") {
      this.apiservice.getCustomersByEntityId(
        this.selectedBusiness.hash_id,
        this.page.toString(),
      );
    } else if (value == "1") {
      this.apiservice.getCustomersWithDuesByEntityId(
        this.selectedBusiness.hash_id,
        this.page.toString(),
      );
    } else if (value == "2") {
      this.apiservice.getLongAbsentCustomersByEntityId(
        this.selectedBusiness.hash_id,
        this.page.toString(),
      );
    }
  }
  isAccessForEmployeeInvoice: boolean = false;

  selectBusiness(index: any) {
    this.businessListData.forEach((element: any) => {
      element.isSelected = 0;
    });
    this.businessListData[index].isSelected = 1;
    this.selectedBusiness = this.businessListData[index];

    let isEntityForeign = this.selectedBusiness.currency == "INR" ? "0" : "1";

    localStorage.setItem(SM_CONSTANTS.IS_ENTITY_FOREIGN, isEntityForeign);
    sessionStorage.setItem(
      "isEntityIndividual",
      this.selectedBusiness.revenue_model == 2 ? "1" : "0",
    );

    let countryList: any[] = COUNTRY_CODES;

    let selectedCurrency = {
      currency: this.selectedBusiness.currency,
      currencySymbol: this.selectedBusiness.currency_symbol,
      countryCode: this.selectedBusiness.entity_country_code,
      code: countryList.find(
        (country) =>
          country.dial_code === this.selectedBusiness.entity_country_code &&
          country.currency === this.selectedBusiness.currency,
      )?.code,
    };
    sessionStorage.setItem(
      SM_CONSTANTS.CURRENCY_FOR_SUBSCRIPTION_PAYMENT,
      JSON.stringify(selectedCurrency),
    );
    localStorage.setItem(
      SM_CONSTANTS.CURRENT_ENTITY_PUBLIC_PROFILE_HASH_ID,
      this.selectedBusiness.entity_public_hash_id,
    );
    sessionStorage.setItem(
      "shop_service_status",
      this.selectedBusiness.shop_service_status,
    );
    sessionStorage.setItem(
      "home_service_status",
      this.selectedBusiness.home_service_status,
    );
    sessionStorage.setItem(
      "virtual_service_status",
      this.selectedBusiness.virtual_service_status,
    );

    sessionStorage.setItem(
      SM_CONSTANTS.EMPLOYEE_SHOP_SERVICE_INVOICE_ACCESS,
      this.selectedBusiness.shop_invoice_access,
    );
    sessionStorage.setItem(
      SM_CONSTANTS.EMPLOYEE_HOME_SERVICE_INVOICE_ACCESS,
      this.selectedBusiness.home_invoice_access,
    );
    sessionStorage.setItem(
      SM_CONSTANTS.EMPLOYEE_VIRTUAL_SERVICE_INVOICE_ACCESS,
      this.selectedBusiness.virtual_invoice_access,
    );

    localStorage.setItem(
      SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID,
      this.selectedBusiness.employee_hash_id,
    );

    this.isAccessForEmployeeInvoice = false;
    this.authService.setUserRole(
      this.selectedBusiness.is_owner == 1 ? "owner" : "employee",
    );
    if (this.selectedBusiness.is_owner == 1) {
      this.isAccessForEmployeeInvoice = true;
    } else {
      const ssa = this.selectedBusiness.shop_invoice_access;
      const hsa = this.selectedBusiness.home_invoice_access;
      const vsa = this.selectedBusiness.virtual_invoice_access;

      const bsss = this.selectedBusiness.shop_service_status;
      const bhss = this.selectedBusiness.home_service_status;
      const bvss = this.selectedBusiness.virtual_service_status;

      // sessionStorage.getItem() returns a string or null.

      // 2. Check if ANY of the retrieved values is the string '1'
      if (
        (ssa == "1" && bsss != "2") ||
        (hsa == "1" && bhss != "2") ||
        (vsa == "1" && bvss != "2")
      ) {
        this.isAccessForEmployeeInvoice = true;
      }
    }

    this.hidediv = true;
    this.loaderservice.showLoader = true;
    this.changeChip("0");
  }

  firstTimeBelow3: boolean = false;

  searchServiceData() {
    if (this.searchString.value.length >= 3) {
      this.firstTimeBelow3 = true;
      this.page = 1;
      this.apiservice.getCustomerDataByKeyword(
        this.selectedBusiness.hash_id,
        this.page,
        this.searchString.value,
        this.selectedValue,
      );
    } else {
      if (this.firstTimeBelow3) {
        this.firstTimeBelow3 = false;
        this.page = 1;
        if (this.selectedValue == "0") {
          this.apiservice.getCustomersByEntityId(
            this.selectedBusiness.hash_id,
            this.page.toString(),
          );
        } else if (this.selectedValue == "1") {
          this.apiservice.getCustomersWithDuesByEntityId(
            this.selectedBusiness.hash_id,
            this.page.toString(),
          );
        } else if (this.selectedValue == "2") {
          this.apiservice.getLongAbsentCustomersByEntityId(
            this.selectedBusiness.hash_id,
            this.page.toString(),
          );
        }
      }
    }
  }

  reset() {
    this.firstTimeBelow3 = false;
    this.searchString.reset();
    this.page = 1;
    if (this.selectedValue == "0") {
      this.apiservice.getCustomersByEntityId(
        this.selectedBusiness.hash_id,
        this.page.toString(),
      );
    } else if (this.selectedValue == "1") {
      this.apiservice.getCustomersWithDuesByEntityId(
        this.selectedBusiness.hash_id,
        this.page.toString(),
      );
    } else if (this.selectedValue == "2") {
      this.apiservice.getLongAbsentCustomersByEntityId(
        this.selectedBusiness.hash_id,
        this.page.toString(),
      );
    }
  }

  ngOnDestroy(): void {
    this.apisub.unsubscribe();
  }

  openvideo() {
    this.dialog.open(YoutubeEmbedVideoComponent, {
      width: "1000px",
      disableClose: true,
      data: {
        link: "https://www.youtube.com/embed/PGWMD0qBbzo?si=ph8Gw-2kAVQN8evr",
        title: "Setting Business Hours in LookzUp Web Portal.",
      },
    });
  }

  opencontact() {
    this.router.navigate(["/contact-us"]);
  }

  viewdetailsopen(item: any) {
    this.authService.setUserRole(
      this.selectedBusiness.is_owner == 1 ? "owner" : "employee",
    );

    this.router.navigate(["customers-details"], {
      relativeTo: this.route,
      queryParams: {
        entityHash: this.selectedBusiness.hash_id,
        countryCode: item.country_code,
        phone: item.phone,
        name: item.name,
      },
    });
    // this.dialogService.openFullScreenDialog(CustomersViewDetailsComponent,data);
  }
  discountInfo: any = null;

  createInvoice(customer: any) {
    let data = {
      title: "New Invoice",
      ref: this._modelRef,
      data: {
        entityHash: this.selectedBusiness.hash_id,
        customer: customer,
        discountInfo: this.discountInfo,
      },
    };
    // this._modelRef.open(AddNewBookingComponent, {
    //   width: '700px',
    //   data: {
    //     title: 'New Booking',
    //     ref: this._modelRef,
    //     data: data
    //   },
    // });
    this.dialogService.openFullScreenDialog(
      CreateInvoiceForCustomersComponent,
      data,
    );
  }

  addcustomer() {
    let data = {
      entityHash: this.selectedBusiness.hash_id,
      eph: this.selectedBusiness.entity_public_hash_id,
      link: "",
      title: "Add customer",
    };

    let dialogref = this.dialogService.openFullScreenDialog(
      AddCustomerComponent,
      data,
    );
    dialogref.afterClosed().subscribe((res) => {
      if (res.resData) {
        if (res.resData[0].errorcode == 1) {
          const dialogRef = this.dialog.open(CustomConfirmDialogComponent, {
            width: "500px",
            data: {
              title: "Alert",
              message:
                "There's another customer with the same name and phone number exists. If you really want to create one, change the name or phone number.",
              okbtn: "Ok",
              cancelbtn: "Cancel",
              type: SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE,
            },
            disableClose: true,
          });
        } else {
          this.loaderservice.showLoader = true;
          this.apiservice.getCustomersByEntityId(
            this.selectedBusiness.hash_id,
            this.page.toString(),
          );
        }
      }
    });
  }

  openAllBookings(item: any) {
    console.log(item);
    sessionStorage.setItem("cusphoneforbill", item.country_code);
    this.router.navigate(["all-bookings"], {
      relativeTo: this.route,
      queryParamsHandling: "merge",
      queryParams: {
        phone: item.phone,
        mn: item.name,
        entityHash: this.selectedBusiness.hash_id,
        eph: this.selectedBusiness.entity_public_hash_id,
      },
    });
  }
  openAllPayments(item: any) {
    console.log(item);
    sessionStorage.setItem("cusphoneforbill", item.country_code);
    this.router.navigate(["all-payments"], {
      relativeTo: this.route,
      queryParamsHandling: "merge",
      queryParams: {
        phone: item.phone,
        code: item.country_code,
        mn: item.name,
        entityHash: this.selectedBusiness.hash_id,
        eph: this.selectedBusiness.entity_public_hash_id,
      },
    });
  }
  openDueBookings(item: any) {
    sessionStorage.setItem("cusphoneforbill", item.country_code);
    this.router.navigate(["due-bookings"], {
      relativeTo: this.route,
      queryParamsHandling: "merge",
      queryParams: {
        phone: item.phone,
        mn: item.name,
        entityHash: this.selectedBusiness.hash_id,
        eph: this.selectedBusiness.entity_public_hash_id,
      },
    });
  }

  msg: any;
 openPaymentIntimation(item: any) {
  let data = {
    title: "Payment Intimation",
    ref: this._modelRef,
    data: item,
    type: 1,
    entity_hash: this.selectedBusiness.hash_id

  }
    this.dialogService.openFullScreenDialog(PaymentIntimationComponent,data);
  }

  deleteCustomer(item: any) {
    const dialogRef = this._modelRef.open(CustomConfirmDialogComponent, {
      data: {
        title: "Alert",
        message: "Are you sure you want to delete this customer?",
        okbtn: "Yes",
        cancelbtn: "No",
        type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log(result);
      if (result) {
        let obj = {
          customerHash: item.hash_id,
          entityHash: this.selectedBusiness.hash_id,
        };

        this.loaderservice.showLoader = true;
        this.apiservice.deleteEntityCustomer(obj);
      }
    });
  }

  selectcountry() {
    let dialogref = this.dialog.open(SelectBusinessCountryComponent, {
      width: "500px",
      disableClose: true,
      data: {
        link: "",
        title: "Select business country",
        ref: this.dialog,
      },
    });
    dialogref.afterClosed().subscribe((res) => {
      if (res) {
        this.router.navigate(["purchased-plan"]);
      }
    });
  }

  formatDateToReadable(date: Date): string {
    // Use Angular's formatDate utility for localization and formatting
    return formatDate(date, "MMM d, y", "en-US");
  }
}
